import React from 'react';
import clsx from 'clsx';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuList from '@material-ui/core/MenuList';
import MenuListItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router-dom';

import {
  About,
  ProfileAvatar,
  OutsideClickTracker,
  showToast,
} from '@shared/components';
import {
  DEFAULT_ERROR_MESSAGE,
  TOAST_TYPES,
  sessionExpireMsg,
} from '@shared/constants';
import { UserService } from '@consumers/services';
import { AuthContext, UserContext } from '@shared/contexts';
import SignOutIcon from '@assets/icons/sign-out-blue.svg';
import useStyles from './style.js';

const noop = () => {};

/**
 * Logout a user from application
 * @param {Function} history
 * @param {Function} getToken
 * @param {Function} removeAuth
 */
const logoutUser = async (history, getToken, removeAuth) => {
  const { error } = await UserService.logoutUser(getToken());
  if (!error) {
    removeAuth();
    history.push('/');
  } else {
    showToast(sessionExpireMsg, TOAST_TYPES.ERROR);
  }
};

/**
 * Profile menu component for the header of application.
 * @param {Function} history
 */
const ProfileMenu = ({ getVersion = () => {}, history }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const [version, setVersion] = React.useState({
    build: 0,
    release: 0,
  });
  const [arrowRef, setArrowRef] = React.useState(null);
  const { userData } = React.useContext(UserContext);
  const { getToken, removeAuth } = React.useContext(AuthContext);
  const { firstName = '', lastName = '' } = userData;
  const avatar = React.useMemo(
    () => <ProfileAvatar userData={userData} />,
    [userData]
  );

  const [anchorRef, setAnchorRef] = React.useState(null);
  const classes = useStyles();

  // const fetchVersion = React.useCallback(async () => {
  //   const { data, error } = await getVersion();
  //   if (error) {
  //     showToast(DEFAULT_ERROR_MESSAGE, TOAST_TYPES.ERROR);
  //   } else {
  //     setVersion({
  //       build: data.build,
  //       release: data.release,
  //     });
  //   }
  // }, [getVersion]);

  // React.useEffect(() => {
  //   fetchVersion();
  // }, [fetchVersion]);

  return (
    <OutsideClickTracker
      onClickAway={() => setIsOpen(false)}
      isListening={isOpen}
    >
      <>
        <ProfileAvatar
          className='c-pointer mr-6'
          userData={userData}
          onClick={event => {
            setAnchorRef(event.currentTarget);
            setIsOpen(prevState => !prevState);
          }}
        />
        <div className='popper-root'>
          <Popper
            open={isOpen}
            anchorEl={anchorRef}
            disablePortal
            className='popper-w-arrow'
            placement='bottom-end'
            keepMounted
            modifiers={{
              hide: {
                enabled: false,
              },
              arrow: {
                enabled: true,
                element: arrowRef,
              },
              flip: {
                enabled: false,
              },
              preventOverflow: {
                enabled: false,
                boundariesElement: 'scrollParent',
              },
            }}
          >
            <span className='popper-arrow' ref={setArrowRef} />
            <Paper elevation={4} className={classes.paper}>
              <div
                className={clsx('d-flex', 'p-6', classes.profileDetailsWrapper)}
              >
                {avatar}
                <div className='pl-5'>
                  <Typography
                    className={classes.userName}
                    variant='body1'
                  >{`${firstName} ${lastName}`}</Typography>
                </div>
              </div>
              <MenuList>
                <About
                  classes={{
                    icon: classes.listIcon,
                    label: classes.listText,
                  }}
                  version={version}
                />
                <MenuListItem
                  onClick={() => logoutUser(history, getToken, removeAuth)}
                >
                  <ListItemIcon className={classes.listIcon}>
                    <img alt='Sign out' src={SignOutIcon} />
                  </ListItemIcon>
                  <ListItemText
                    primary='Sign out'
                    className={classes.listText}
                  />
                </MenuListItem>
              </MenuList>
            </Paper>
          </Popper>
        </div>
      </>
    </OutsideClickTracker>
  );
};

export default withRouter(ProfileMenu);
